import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { SubSink } from "subsink";
import { MemberDataLoadState } from "../../api/member-v2/member-data-load-state-modal";
import { MemberV2Service } from "../../api/member-v2/member-v2.service";
import { DataLoadState } from "./data-load-state.model";
import { DataLoadService } from "./data-load.service";

@Component({
  selector: "app-data-load",
  templateUrl: "./data-load.component.html",
  styleUrls: ["./data-load.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataLoadComponent implements OnInit, OnDestroy {
  private sink = new SubSink();
  dataLoadState: DataLoadState;
  memberDataLoadState: MemberDataLoadState;

  constructor(
    private readonly changeDetector: ChangeDetectorRef,
    private dataLoadService: DataLoadService,
    private memberService: MemberV2Service,
    private router: Router
  ) { }

  get confirmationHeaderText(): string {
    if (this.memberDataLoadState?.dataLoadId) {
      return "Your member data load was successful";
    } else if (this.dataLoadState.isDelete) {
      return "Your data load delete was successful";
    } else if (this.dataLoadState.isAdminRefresh) {
      return "Your data load refresh was successful";
    } else {
      return "Your data load was successful";
    }
  }

  ngOnInit() {
    this.sink.add(
      this.dataLoadService.state.subscribe(state => {
        this.dataLoadState = state;
        this.changeDetector.markForCheck();
      }),
      this.memberService.state.subscribe(state => {
        this.memberDataLoadState = state;
        this.changeDetector.markForCheck();
      })
    );
  }

  ngOnDestroy() {
    this.sink.unsubscribe();
    this.dataLoadService.clearState();
    this.memberService.clearState();
  }

  newLoad(): void {
    this.dataLoadService.clearState();
    this.memberService.clearState();
  }

  goToChaseQuery(): Promise<boolean> {
    return this.router.navigateByUrl(`/query/chasequery/${this.dataLoadState.projectId}`);
  }
}
